import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import _get from 'lodash/get';
import Bind from 'lodash-decorators/bind';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';

//styles
import styles from './ArticleDetailPage.module.scss';

//components
import { Container, Title } from 'common/components/Layout/Layout';
import ArticleNoteSmReduced from './components/ArticleNoteSmReduced/ArticleNoteSmReduced';
import FileToDownload from 'common/components/FileToDownload/FileToDownload';
import ArticlePrintings from './components/ArticlePrintings/ArticlePrintings';
import ContactPerson from 'common/components/ContactPerson/ContactPerson';
import ArticleContentWrapper from './components/ArticleContentWrapper/ArticleContentWrapper';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import ArticleBig from 'common/components/Placeholder/components/ArticleBig/ArticleBig';
import ArticleSmall from 'common/components/Placeholder/components/ArticleSmall/ArticleSmall';

import Link from 'common/components/LocalizedLink/LocalizedLink';

import LanguageService from 'services/Language.service';
import ContentStore from 'stores/Content.store';

@injectIntl
@withRouter
@observer
export default class ArticleDetail extends Component {
  contactPerson = {};

  async componentDidMount() {
    reaction(
      () => ContentStore.isLoaded,
      () => {
        this.contactPerson = ContentStore.content
          ? ContentStore.content.pressRoomContactPerson
          : {};
      },
      {
        fireImmediately: true
      }
    );
  }

  @Bind
  goBack() {
    this.props.history.goBack();
  }

  renderFilesToDownload(article) {
    const { messages } = this.props;
    const bannerImage = article.photo;
    const articleCategories = article.pressRoomCategory
      ? article.pressRoomCategory.value
      : '';
    let logosToShow = [];

    if (articleCategories) {
      logosToShow = ContentStore.content.companiesLogos.filter(cachedLogo => {
        return articleCategories.some(
          articleLogo => articleLogo.codename === cachedLogo.pressRoomCategory
        );
      });
    }

    const { filesName, filesSize, filesUrl } = article;

    return (
      <div>
        <FileToDownload
          title={bannerImage.name}
          size={bannerImage.size}
          url={bannerImage.url}
        />
        {logosToShow.map(logo => {
          return (
            <FileToDownload
              key={logo.file.id}
              title={logo.file.name}
              size={logo.file.size}
              url={logo.file.url}
            />
          );
        })}
        {filesUrl && (
          <div>
            <h3
              className={`${styles.SidebarOthersToDownload} ${
                styles.SidebarZipFilesToDownload
              }`}
            >
              {this.props.intl.formatMessage(messages.zipFilesToDownload)}
            </h3>
            <FileToDownload
              title={filesName}
              size={filesSize}
              url={filesUrl}
              hideImg
            />
          </div>
        )}
      </div>
    );
  }

  renderOtherNews() {
    const otherNews = _get(this.props, 'otherNews', []).filter(
      el => el.system.id !== this.props.article.system.id
    );

    return (
      <div>
        {otherNews.map((news, index) => {
          return (
            <ArticleNoteSmReduced key={news.system.codename} news={news} />
          );
        })}
      </div>
    );
  }

  render() {
    const {
      messages,
      didComeFromListing,
      article,
      viewWithOnlyArticle,
      defaultPreviousPath
    } = this.props;
    return (
      <div className={styles.ArticleContainer}>
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Container>
          {article && <InjectMetaTags {...article.seo} noIndex="noindex" />}
          <div className={`${styles.ContainerArticle} `}>
            <div className={styles.ReturnDiv}>
              <i className={styles.ArrowLeft} />
              {didComeFromListing() ? (
                <span className={styles.Return} onClick={this.goBack}>
                  {this.props.intl.formatMessage(messages.return)}
                </span>
              ) : (
                <Link
                  to={defaultPreviousPath[LanguageService.getLang()]}
                  className={styles.Return}
                >
                  {this.props.intl.formatMessage(messages.return)}
                </Link>
              )}
            </div>
            <Placeholder component={<ArticleBig />} ready={!!article}>
              <ArticleContentWrapper
                article={article}
                viewWithOnlyArticle={viewWithOnlyArticle}
                className={styles.MarginTop}
              />
            </Placeholder>
          </div>
          <div className={`${styles.SidebarColumn}`}>
            {!viewWithOnlyArticle && (
              <h3 className={styles.SidebarTitleFilesToDownload}>
                {this.props.intl.formatMessage(messages.journalistContact)}
              </h3>
            )}
            <Placeholder
              repeat={2}
              component={<ArticleSmall />}
              ready={!!article}
            >
              {ContentStore.isLoaded &&
                !viewWithOnlyArticle && (
                  <ContactPerson person={this.contactPerson} />
                )}
              <h3 className={styles.SidebarTitleFilesToDownload}>
                {this.props.intl.formatMessage(messages.filesToDownload)}
              </h3>

              {article && (
                <div>
                  <ArticlePrintings
                    formatTXT={article.txt}
                    formatDOC={article.doc}
                    formatPDF={article.pdf}
                    formatIMG={article.img}
                    type={article.type}
                  />
                  {/* <h3 className={styles.SidebarOthersToDownload}>
                    {this.props.intl.formatMessage(messages.graphicsToDownload)}
                  </h3> */}
                  {/* {ContentStore.isLoaded && this.renderFilesToDownload(article)} */}
                  {!viewWithOnlyArticle && (
                    <>
                      {' '}
                      <h3
                        className={`${styles.SidebarTitleFilesToDownload} ${
                          styles.SidebarOtherNews
                        }`}
                      >
                        {this.props.intl.formatMessage(messages.otherNews)}
                      </h3>
                      {this.renderOtherNews()}
                    </>
                  )}
                </div>
              )}
            </Placeholder>
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/ArticleDetailPage.js